import { Injectable, signal, computed } from '@angular/core';
import type { AuthState, User, AuthToken } from './auth.model';

const initialState: AuthState = {
  user: null,
  token: null,
  isLoading: false,
  error: null,
};

@Injectable({ providedIn: 'root' })
export class AuthSessionStore {
  private readonly state = signal<AuthState>(initialState);

  readonly user = computed(() => this.state().user);
  readonly token = computed(() => this.state().token);
  readonly isLoading = computed(() => this.state().isLoading);
  readonly error = computed(() => this.state().error);
  readonly isAuthenticated = computed(() => this.state().user !== null && this.state().token !== null);

  setLoading(isLoading: boolean): void {
    this.state.update((s) => ({ ...s, isLoading }));
  }

  setUser(user: User | null): void {
    this.state.update((s) => ({ ...s, user, error: null }));
  }

  setToken(token: AuthToken | null): void {
    this.state.update((s) => ({ ...s, token }));
  }

  setError(error: string | null): void {
    this.state.update((s) => ({ ...s, error }));
  }

  logout(): void {
    this.state.set(initialState);
  }

  restoreSession(user: User, token: AuthToken): void {
    this.state.set({ user, token, isLoading: false, error: null });
  }
}
